/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Customproduktlekocurrent4Inputs */

const de__field_customproduktlekocurrent4 = /** @type {(inputs: _Field_Customproduktlekocurrent4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt-SchuKo-Bedarf aktueller Wert`)
};

/**

* @param {_Field_Customproduktlekocurrent4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_customproduktlekocurrent4 = /** @type {((inputs?: _Field_Customproduktlekocurrent4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Customproduktlekocurrent4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_customproduktlekocurrent4(inputs)
});
export { _field_customproduktlekocurrent4 as "_field_customProduktLeKoCurrent" }